export const THEME = {
	cssVar: true,

	token: {
		'blue.1': '#e6f4ff',
		'blue.2': '#bae0ff',
		'blue.3': '#91caff',
		'blue.4': '#69b1ff',
		'blue.5': '#4096ff',
		'blue.6': '#1677ff',
		'blue.7': '#0958d9',
		'blue.8': '#003eb3',
		'blue.9': '#002c8c',
		'blue.10': '#001d66',
		'cyan.1': '#e6fffb',
		'cyan.2': '#b5f5ec',
		'cyan.3': '#87e8de',
		'cyan.4': '#5cdbd3',
		'cyan.5': '#36cfc9',
		'cyan.6': '#13c2c2',
		'cyan.7': '#08979c',
		'cyan.8': '#006d75',
		'cyan.9': '#00474f',
		'cyan.10': '#002329',
		'geekblue.1': '#f0f5ff',
		'geekblue.2': '#d6e4ff',
		'geekblue.3': '#adc6ff',
		'geekblue.4': '#85a5ff',
		'geekblue.5': '#597ef7',
		'geekblue.6': '#2f54eb',
		'geekblue.7': '#1d39c4',
		'geekblue.8': '#10239e',
		'geekblue.9': '#061178',
		'geekblue.10': '#030852',
		'gold.1': '#fffbe6',
		'gold.2': '#fff1b8',
		'gold.3': '#ffe58f',
		'gold.4': '#ffd666',
		'gold.5': '#ffc53d',
		'gold.6': '#faad14',
		'gold.7': '#d48806',
		'gold.8': '#ad6800',
		'gold.9': '#874d00',
		'gold.10': '#613400',
		'green.1': '#f6ffed',
		'green.2': '#d9f7be',
		'green.3': '#b7eb8f',
		'green.4': '#95de64',
		'green.5': '#73d13d',
		'green.6': '#52c41a',
		'green.7': '#389e0d',
		'green.8': '#237804',
		'green.9': '#135200',
		'green.10': '#092b00',
		'lime.1': '#fcffe6',
		'lime.2': '#f4ffb8',
		'lime.3': '#eaff8f',
		'lime.4': '#d3f261',
		'lime.5': '#bae637',
		'lime.6': '#a0d911',
		'lime.7': '#7cb305',
		'lime.8': '#5b8c00',
		'lime.9': '#3f6600',
		'lime.10': '#254000',
		'magenta.1': '#fff0f6',
		'magenta.2': '#ffd6e7',
		'magenta.3': '#ffadd2',
		'magenta.4': '#ff85c0',
		'magenta.5': '#f759ab',
		'magenta.6': '#eb2f96',
		'magenta.7': '#c41d7f',
		'magenta.8': '#9e1068',
		'magenta.9': '#780650',
		'magenta.10': '#520339',
		'orange.1': '#fff7e6',
		'orange.2': '#ffe7ba',
		'orange.3': '#ffd591',
		'orange.4': '#ffc069',
		colorText: '#1e1e1f',
		colorTextSecondary: '#4f5153',
		'orange.5': '#ffa940',
		colorTextTertiary: '#828486',
		colorTextQuaternary: '#c1c1c3',
		'orange.6': '#fa8c16',
		'orange.7': '#d46b08',
		colorTextLightSolid: '#ffffff',
		colorTextHeading: '#1e1e1f',
		colorTextLabel: '#4f5153',
		'orange.8': '#ad4e00',
		colorTextDescription: '#828486',
		'orange.9': '#873800',
		colorTextDisabled: '#c1c1c3',
		'orange.10': '#612500',
		'purple.1': '#f9f0ff',
		'purple.2': '#efdbff',
		'purple.3': '#d3adf7',
		colorTextPlaceholder: '#c1c1c3',
		colorIcon: '#828486',
		'purple.4': '#b37feb',
		colorIconHover: '#1e1e1f',
		colorBgContainer: '#ffffff',
		'purple.5': '#9254de',
		colorBgElevated: '#ffffff',
		'purple.6': '#722ed1',
		colorBgLayout: '#f5f5f5',
		'purple.7': '#531dab',
		colorBgMask: 'rgba(130, 132, 134, 0.60)',
		'purple.8': '#391085',
		colorBgSpotlight: '#28282a',
		'purple.9': '#22075e',
		colorBorder: '#e0e0e1',
		'purple.10': '#120338',
		colorBorderSecondary: '#eff0f0',
		'red.1': '#fff1f0',
		colorFill: '#d0d1d2',
		'red.2': '#ffccc7',
		colorFillSecondary: '#e0e0e1',
		colorFillTertiary: '#eff0f0',
		colorFillQuaternary: '#eff0f0',
		'red.3': '#ffa39e',
		'red.4': '#ff7875',
		colorWhite: '#ffffff',
		'red.5': '#ff4d4f',
		colorBgBase: '#ffffff',
		'red.6': '#f5222d',
		colorTextBase: '#141415',
		'red.7': '#cf1322',
		'red.8': '#a8071a',
		colorBgContainerDisabled: '#eff0f0',
		'red.9': '#820014',
		colorBgTextActive: '#d0d1d2',
		'red.10': '#5c0011',
		colorBgTextHover: '#e0e0e1',
		'volcano.1': '#fff2e8',
		colorBorderBg: '#ffffff',
		'volcano.2': '#ffd8bf',
		colorFillContent: '#e0e0e1',
		'volcano.3': '#ffbb96',
		colorFillContentHover: '#d0d1d2',
		'volcano.4': '#ff9c6e',
		colorFillAlter: '#eff0f0',
		'volcano.5': '#ff7a45',
		'volcano.6': '#fa541c',
		'volcano.7': '#d4380d',
		transparent: 'rgba(0, 0, 0, 0)',
		colorSplit: '#eff0f0',
		'yellow.1': '#feffe6',
		'volcano.8': '#ad2102',
		'yellow.2': '#ffffb8',
		'yellow.3': '#fffb8f',
		'volcano.9': '#871400',
		'yellow.4': '#fff566',
		'volcano.10': '#610b00',
		'yellow.5': '#ffec3d',
		'yellow.6': '#fadb14',
		'yellow.7': '#d4b106',
		'yellow.8': '#ad8b00',
		'yellow.9': '#876800',
		'yellow.10': '#614700',
		colorPrimary: '#13c2c2',
		colorSuccess: '#52c41a',
		colorWarning: '#faad14',
		colorInfo: '#13c2c2',
		colorError: '#ff4d4f',
		colorLink: '#13c2c2',
		colorErrorBg: '#fff2f0',
		colorErrorBgHover: '#fff1f0',
		colorErrorBorder: '#ffccc7',
		colorErrorBorderHover: '#ffa39e',
		colorErrorHover: '#ff7875',
		colorErrorActive: '#d9363e',
		colorErrorTextHover: '#ff7875',
		colorErrorText: '#ff4d4f',
		colorErrorTextActive: '#d9363e',
		colorLinkHover: '#36cfc9',
		colorInfoBg: '#e6fffb',
		colorInfoBgHover: '#b5f5ec',
		colorInfoBorder: '#87e8de',
		colorInfoBorderHover: '#5cdbd3',
		colorInfoHover: '#36cfc9',
		colorInfoActive: '#08979c',
		colorInfoTextHover: '#36cfc9',
		colorInfoText: '#13c2c2',
		colorInfoTextActive: '#08979c',
		colorLinkActive: '#08979c',
		colorPrimaryBg: '#e6fffb',
		colorPrimaryBgHover: '#b5f5ec',
		colorPrimaryBorder: '#87e8de',
		colorPrimaryBorderHover: '#5cdbd3',
		colorPrimaryHover: '#36cfc9',
		colorPrimaryActive: '#08979c',
		colorPrimaryTextHover: '#36cfc9',
		colorPrimaryText: '#13c2c2',
		colorPrimaryTextActive: '#08979c',
		colorSuccessBg: '#f6ffed',
		colorSuccessBgHover: '#d9f7be',
		colorSuccessBorder: '#b7eb8f',
		colorSuccessBorderHover: '#95de64',
		colorSuccessHover: '#95de64',
		colorSuccessActive: '#389e0d',
		colorSuccessTextHover: '#73d13d',
		colorSuccessText: '#52c41a',
		colorSuccessTextActive: '#389e0d',
		colorWarningBg: '#fffbe6',
		colorWarningBgHover: '#fff1b8',
		colorWarningBorder: '#ffe58f',
		colorWarningBorderHover: '#ffd666',
		colorWarningHover: '#ffd666',
		colorWarningActive: '#d48806',
		colorWarningTextHover: '#ffc53d',
		colorWarningText: '#faad14',
		colorWarningTextActive: '#d48806',
		colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
		colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
		controlItemBgActive: '#e6fffb',
		controlItemBgActiveDisabled: '#d0d1d2',
		controlItemBgActiveHover: '#b5f5ec',
		controlItemBgHover: '#eff0f0',
		controlOutline: 'rgba(5, 145, 255, 0.1)',
		controlTmpOutline: '#eff0f0',
		borderRadius: 8,
		borderRadiusLG: 12,
		borderRadiusSM: 6,
		borderRadiusXS: 4,
		sizeStep: 4,
		sizeUnit: 4,
		controlInteractiveSize: 16,
		size: 16,
		sizeLG: 24,
		sizeMD: 20,
		sizeMS: 16,
		sizeSM: 12,
		sizeXL: 32,
		sizeXS: 8,
		sizeXXL: 48,
		controlHeight: 40,
		sizeXXS: 4,
		controlHeightLG: 44,
		controlHeightSM: 36,
		controlHeightXS: 30,
		lineWidth: 1,
		lineWidthBold: 2,
		lineWidthFocus: 4,
		controlOutlineWidth: 2,
		screenLG: 992,
		screenLGMax: 1199,
		screenLGMin: 992,
		screenMD: 768,
		screenMDMax: 991,
		screenMDMin: 768,
		screenSM: 576,
		screenSMMax: 767,
		screenSMMin: 576,
		screenXL: 1200,
		screenXLMax: 1599,
		screenXLMin: 1200,
		screenXS: 480,
		screenXSMax: 575,
		screenXSMin: 480,
		screenXXL: 1600,
		screenXXLMin: 1600,
		sizePopupArrow: 16,
		margin: 16,
		marginLG: 24,
		marginMD: 20,
		marginSM: 12,
		marginXL: 32,
		marginXS: 8,
		marginXXL: 48,
		marginXXS: 4,
		padding: 16,
		paddingLG: 24,
		paddingMD: 20,
		paddingSM: 12,
		paddingXL: 32,
		paddingXS: 8,
		paddingXXS: 4,
		paddingContentHorizontal: 16,
		paddingContentHorizontalLG: 24,
		paddingContentHorizontalSM: 16,
		paddingContentVertical: 12,
		paddingContentVerticalLG: 16,
		paddingContentVerticalSM: 8,
		controlPaddingHorizontal: 12,
		controlPaddingHorizontalSM: 8,
		fontFamily: 'Roboto',
		fontFamilyCode: 'Roboto Mono',
		fontSize: 14,
		fontSizeLG: 16,
		fontSizeSM: 12,
		fontSizeXL: 20,
		fontSizeHeading1: 38,
		fontSizeHeading2: 30,
		fontSizeHeading3: 24,
		fontSizeHeading4: 20,
		fontSizeHeading5: 16,
		lineHeight: 1.5714285714285714,
		lineHeightHeading1: 1.2105263157894737,
		lineHeightHeading2: 1.2666666666666666,
		lineHeightHeading3: 1.3333333333333333,
		lineHeightHeading4: 1.4,
		lineHeightHeading5: 1.5,
		lineHeightLG: 1.5,
		lineHeightSM: 1.6666666666666667,
		fontSizeIcon: 12,
		fontWeightStrong: 600,
		colorFillAlterSolid: '#eff0f0',
		fontWeightNormal: 400,
		colorFilledHandleBg: '#ffffff',
		'greyCold.0': '#ffffff',
		'greyCold.5': '#eff0f0',
		'greyCold.10': '#e0e0e1',
		'greyCold.15': '#d0d1d2',
		'greyCold.20': '#c1c1c3',
		'greyCold.30': '#a1a3a4',
		'greyCold.40': '#828486',
		'greyCold.50': '#636568',
		'greyCold.60': '#4f5153',
		'greyCold.70': '#3b3d3e',
		'greyCold.80': '#28282a',
		'greyCold.85': '#1e1e1f',
		'greyCold.90': '#141415',
		'greyCold.95': '#0a0a0a',
		'greyCold.100': '#000000',
		fontFamilyHeader: 'Roboto',
		'folly.1': '#fff2e8',
		'folly.2': '#ffd8bf',
		'folly.3': '#ffbb96',
		'folly.4': '#ff9c6e',
		'folly.5': '#ff7a45',
		'folly.6': '#fa541c',
		'folly.7': '#d4380d',
		'folly.8': '#ad2102',
		'folly.9': '#871400',
		'folly.10': '#610b00',
	},
	components: {
		Input: {
			paddingInlineSM: 7,
			paddingInlineLG: 12,
			paddingInline: 12,
			paddingBlockSM: 0,
			paddingBlockLG: 9,
			paddingBlock: 8,
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			paddingLG: 24,
			lineWidth: 1,
			lineHeightLG: 1.5,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSizeIcon: 12,
			fontSize: 14,
			controlPaddingHorizontalSM: 8,
			controlPaddingHorizontal: 12,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
			colorWarningBorderHover: '#ffd666',
			colorWarning: '#faad14',
			colorTextTertiary: '#828486',
			colorTextQuaternary: '#c1c1c3',
			colorTextPlaceholder: '#c1c1c3',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimary: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorFillAlter: '#eff0f0',
			colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
			colorErrorBorderHover: '#ffa39e',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			hoverBorderColor: '#36cfc9',
			addonBg: '#eff0f0',
			activeBorderColor: '#13c2c2',
			colorFillTertiary: '#eff0f0',
			colorFillSecondary: '#e0e0e1',
			colorErrorBgHover: '#fff1f0',
			colorErrorBg: '#fff2f0',
			colorWarningBg: '#fffbe6',
			colorWarningBgHover: '#fff1b8',
			colorWarningText: '#faad14',
			colorErrorText: '#ff4d4f',
			activeBg: '#ffffff',
			hoverBg: '#ffffff',
			inputFontSize: 14,
			inputFontSizeLG: 16,
			inputFontSizeSM: 12,
			fontFamily: 'Roboto',
		},
		Transfer: {
			listWidthLG: 250,
			listWidth: 180,
			listHeight: 200,
			itemPaddingBlock: 5,
			paddingXS: 8,
			paddingSM: 12,
			marginXXS: 4,
			marginXS: 8,
			margin: 16,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeIcon: 12,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlItemBgActiveHover: '#b5f5ec',
			controlItemBgActive: '#e6fffb',
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusLG: 12,
			colorWarning: '#faad14',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorLinkHover: '#36cfc9',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			itemHeight: 40,
			headerHeight: 44,
			fontFamily: 'Roboto',
		},
		Segmented: {
			segmentedBgColorSelected: '#ffffff',
			paddingXXS: 4,
			marginSM: 12,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlPaddingHorizontalSM: 8,
			controlPaddingHorizontal: 12,
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusXS: 4,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorTextLabel: '#4f5153',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorFillSecondary: '#e0e0e1',
			colorFill: '#d0d1d2',
			colorBgLayout: '#f5f5f5',
			colorBgElevated: '#ffffff',
			segmentedGroupBg: '#eff0f0',
			itemSelectedColor: '#1e1e1f',
			itemSelectedBg: '#ffffff',
			itemHoverColor: '#1e1e1f',
			itemHoverBg: '#e0e0e1',
			itemColor: '#4f5153',
			itemActiveBg: '#d0d1d2',
			trackPadding: 2,
			trackBg: '#f5f5f5',
			fontFamily: 'Roboto',
		},
		Switch: {
			trackPadding: 2,
			trackMinWidthSM: 28,
			trackMinWidth: 44,
			trackHeightSM: 16,
			trackHeight: 22,
			handleSizeSM: 12,
			handleSize: 18,
			marginXXS: 4,
			lineWidthFocus: 4,
			lineHeight: 1.5714285714285714,
			fontSizeSM: 12,
			fontSizeIcon: 12,
			fontSize: 14,
			controlHeight: 40,
			colorWhite: '#ffffff',
			colorTextTertiary: '#828486',
			colorTextQuaternary: '#c1c1c3',
			colorTextLightSolid: '#ffffff',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			handleBg: '#ffffff',
			fontFamily: 'Roboto',
		},
		TimePicker: {
			timeColumnWidth: 56,
			timeColumnHeight: 224,
			timeCellHeight: 28,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			sizePopupArrow: 16,
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeightLG: 1.5,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeLG: 16,
			fontSize: 14,
			controlPaddingHorizontalSM: 8,
			controlPaddingHorizontal: 12,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusXS: 4,
			borderRadius: 8,
			colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
			colorWarning: '#faad14',
			colorTextQuaternary: '#c1c1c3',
			colorTextPlaceholder: '#c1c1c3',
			colorTextLightSolid: '#ffffff',
			colorTextHeading: '#1e1e1f',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorLinkHover: '#36cfc9',
			colorLinkActive: '#08979c',
			colorLink: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorFillAlter: '#eff0f0',
			colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			colorBgElevated: '#ffffff',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			hoverBorderColor: '#36cfc9',
			cellHoverBg: '#eff0f0',
			cellHeight: 36,
			activeBorderColor: '#13c2c2',
			paddingInline: 11,
			paddingInlineLG: 11,
			paddingInlineSM: 7,
			activeBg: '#ffffff',
			hoverBg: '#ffffff',
			cellBgDisabled: '#eff0f0',
			cellActiveWithRangeBg: '#e6fffb',
			cellHoverWithRangeBg: '#c8dfff',
			cellRangeBorderColor: '#7cb3ff',
			multipleItemBg: '#e0e0e1',
			multipleItemBorderColor: 'rgba(0, 0, 0, 0)',
			multipleItemBorderColorDisabled: 'rgba(0, 0, 0, 0)',
			multipleItemColorDisabled: '#c1c1c3',
			multipleSelectorBgDisabled: '#eff0f0',
			cellWidth: 36,
			multipleItemHeight: 24,
			multipleItemHeightLG: 32,
			multipleItemHeightSM: 16,
			paddingBlock: 4,
			paddingBlockLG: 7,
			paddingBlockSM: 0,
			presetsMaxWidth: 200,
			presetsWidth: 120,
			textHeight: 44,
			withoutTimeCellHeight: 66,
			inputFontSize: 14,
			inputFontSizeLG: 16,
			inputFontSizeSM: 12,
			fontFamily: 'Roboto',
		},
		Timeline: {
			itemPaddingBottom: 20,
			paddingXXS: 4,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			marginSM: 12,
			margin: 16,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeSM: 12,
			fontSize: 14,
			controlHeightLG: 44,
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorSuccess: '#52c41a',
			colorPrimary: '#13c2c2',
			colorError: '#ff4d4f',
			colorBgContainer: '#ffffff',
			tailColor: '#eff0f0',
			dotBg: '#ffffff',
			fontFamily: 'Roboto',
		},
		Tabs: {
			horizontalItemGutter: 32,
			cardGutter: 2,
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			paddingLG: 24,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			marginSM: 12,
			margin: 16,
			lineWidthFocus: 4,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeSM: 12,
			fontSizeLG: 16,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorTextHeading: '#1e1e1f',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimaryActive: '#08979c',
			colorPrimary: '#13c2c2',
			colorFillAlter: '#eff0f0',
			colorBorderSecondary: '#eff0f0',
			colorBorder: '#e0e0e1',
			colorBgContainer: '#ffffff',
			itemSelectedColor: '#13c2c2',
			itemHoverColor: '#36cfc9',
			itemColor: '#1e1e1f',
			itemActiveColor: '#08979c',
			inkBarColor: '#13c2c2',
			cardHeight: 44,
			cardBg: '#eff0f0',
			titleFontSize: 14,
			titleFontSizeLG: 16,
			titleFontSizeSM: 14,
			fontFamily: 'Roboto',
		},
		Table: {
			stickyScrollBarBorderRadius: 100,
			headerSplitColor: '#eff0f0',
			headerBg: '#eff0f0',
			footerBg: '#eff0f0',
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			padding: 16,
			marginXXS: 4,
			margin: 16,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeSM: 12,
			fontSizeIcon: 12,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlItemBgActiveHover: '#b5f5ec',
			controlItemBgActive: '#e6fffb',
			controlInteractiveSize: 16,
			controlHeight: 40,
			borderRadiusLG: 12,
			borderRadius: 6,
			colorTextPlaceholder: '#c1c1c3',
			colorTextHeading: '#1e1e1f',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimary: '#13c2c2',
			colorLinkHover: '#36cfc9',
			colorLinkActive: '#08979c',
			colorLink: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorFillSecondary: '#e0e0e1',
			colorFillContent: '#e0e0e1',
			colorFillAlter: '#eff0f0',
			colorBorderSecondary: '#eff0f0',
			colorBgContainer: '#ffffff',
			rowSelectedHoverBg: '#b5f5ec',
			headerFilterHoverBg: '#e0e0e1',
			headerColor: '#1e1e1f',
			headerBorderRadius: 12,
			rowExpandedBg: '#f5f5f5',
			footerColor: '#1e1e1f',
			filterDropdownMenuBg: '#ffffff',
			filterDropdownBg: '#ffffff',
			cellPaddingInlineSM: 8,
			cellPaddingInlineMD: 8,
			cellPaddingInline: 16,
			cellPaddingBlockSM: 8,
			cellPaddingBlockMD: 12,
			cellPaddingBlock: 16,
			borderColor: '#eff0f0',
			rowHoverBg: '#eff0f0',
			headerSortActiveBg: '#e0e0e1',
			bodySortBg: '#eff0f0',
			headerSortHoverBg: '#e0e0e1',
			cellFontSize: 14,
			cellFontSizeMD: 14,
			cellFontSizeSM: 14,
			fontFamily: 'Roboto',
		},
		Steps: {
			dotSize: 8,
			dotCurrentSize: 10,
			descriptionMaxWidth: 140,
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			paddingLG: 24,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			marginSM: 12,
			marginLG: 24,
			margin: 16,
			lineWidthFocus: 4,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeightSM: 1.6666666666666667,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeSM: 12,
			fontSizeLG: 16,
			fontSizeIcon: 12,
			fontSizeHeading3: 24,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlHeightLG: 44,
			borderRadiusSM: 6,
			colorTextQuaternary: '#c1c1c3',
			colorTextLightSolid: '#ffffff',
			colorTextLabel: '#4f5153',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorFillContent: '#e0e0e1',
			colorError: '#ff4d4f',
			colorBorderSecondary: '#eff0f0',
			colorBorderBg: '#ffffff',
			colorBgContainer: '#ffffff',
			titleLineHeight: 40,
			iconSizeSM: 24,
			iconSize: 40,
			finishIconBorderColor: '#1677ff',
			customIconFontSize: 36,
			iconFontSize: 14,
			fontFamily: 'Roboto',
		},
		Spin: {
			dotSizeSM: 14,
			dotSize: 20,
			contentHeight: 400,
			marginXXS: 4,
			lineHeight: 1.5714285714285714,
			fontSize: 14,
			controlHeightLG: 44,
			controlHeight: 40,
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimary: '#13c2c2',
			colorBgContainer: '#ffffff',
			dotSizeLG: 40,
			fontFamily: 'Roboto',
		},
		Slider: {
			railSize: 4,
			handleSizeHover: 12,
			dotSize: 8,
			controlSize: 10,
			handleSize: 10,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSize: 14,
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusXS: 4,
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimaryBorderHover: '#5cdbd3',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorFillTertiary: '#eff0f0',
			colorFillSecondary: '#e0e0e1',
			colorFillContentHover: '#d0d1d2',
			colorBorderSecondary: '#eff0f0',
			colorBgElevated: '#ffffff',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			trackHoverBg: '#5cdbd3',
			trackBgDisabled: '#eff0f0',
			trackBg: '#87e8de',
			railHoverBg: '#e0e0e1',
			railBg: '#eff0f0',
			handleColor: '#87e8de',
			handleActiveColor: '#13c2c2',
			dotBorderColor: '#eff0f0',
			dotActiveBorderColor: '#87e8de',
			handleColorDisabled: '#bfbfbf',
			fontFamily: 'Roboto',
		},
		Rate: {
			rateStarSize: 20,
			marginXS: 8,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSize: 14,
			controlHeightLG: 44,
			colorText: '#1e1e1f',
			colorFillContent: '#e0e0e1',
			fontFamily: 'Roboto',
		},
		Radio: {
			radioSize: 16,
			dotSize: 8,
			buttonPaddingInline: 15,
			paddingXS: 8,
			padding: 16,
			marginXS: 8,
			lineWidthFocus: 4,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlItemBgActiveDisabled: '#d0d1d2',
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorWhite: '#ffffff',
			colorTextLightSolid: '#ffffff',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimaryActive: '#08979c',
			colorPrimary: '#13c2c2',
			colorBorder: '#e0e0e1',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			wrapperMarginInlineEnd: 8,
			dotColorDisabled: '#c1c1c3',
			buttonSolidCheckedHoverBg: '#36cfc9',
			buttonSolidCheckedColor: '#ffffff',
			buttonSolidCheckedBg: '#13c2c2',
			buttonSolidCheckedActiveBg: '#08979c',
			buttonColor: '#1e1e1f',
			buttonCheckedColorDisabled: '#c1c1c3',
			buttonCheckedBgDisabled: '#d0d1d2',
			buttonCheckedBg: '#ffffff',
			buttonBg: '#ffffff',
			fontFamily: 'Roboto',
			radioBgColor: '#13c2c2',
			radioColor: '#ffffff',
		},
		Popover: {
			titleMinWidth: 177,
			sizePopupArrow: 16,
			paddingSM: 12,
			padding: 16,
			marginXS: 8,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSize: 14,
			controlHeight: 40,
			borderRadiusXS: 4,
			borderRadiusLG: 12,
			colorTextHeading: '#1e1e1f',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorBgElevated: '#ffffff',
			fontFamily: 'Roboto',
		},
		Notification: {
			width: 384,
			paddingMD: 20,
			paddingLG: 24,
			paddingContentHorizontalLG: 24,
			marginXS: 8,
			marginSM: 12,
			marginLG: 24,
			margin: 16,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlHeightLG: 44,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			colorWarning: '#faad14',
			colorTextHeading: '#1e1e1f',
			colorText: '#1e1e1f',
			colorSuccess: '#52c41a',
			colorInfo: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorError: '#ff4d4f',
			colorBgElevated: '#ffffff',
			lineHeightLG: 1.5,
			lineWidthFocus: 4,
			fontFamily: 'Roboto',
		},
		Tooltip: {
			paddingSM: 12,
			sizePopupArrow: 16,
			paddingXS: 8,
			lineHeight: 1.5714285714285714,
			fontSize: 14,
			controlHeight: 32,
			borderRadiusXS: 4,
			borderRadius: 8,
			colorTextLightSolid: '#ffffff',
			colorText: '#1e1e1f',
			colorBgSpotlight: '#28282a',
			fontFamily: 'Roboto',
		},
		Menu: {
			subMenuItemBg: '#eff0f0',
			darkSubMenuItemBg: '#0a0a0a',
			darkItemDisabledColor: '#828486',
			darkItemColor: '#828486',
			darkGroupTitleColor: '#636568',
			darkItemBg: '#031026',
			paddingXS: 8,
			paddingXL: 32,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			margin: 16,
			lineWidthFocus: 4,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlItemBgActive: '#e6fffb',
			controlHeightSM: 36,
			controlHeightLG: 44,
			borderRadius: 8,
			colorSplit: '#eff0f0',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorFillContent: '#e0e0e1',
			colorErrorHover: '#ff7875',
			colorErrorBg: '#fff2f0',
			colorError: '#ff4d4f',
			colorBgElevated: '#ffffff',
			colorBgContainer: '#ffffff',
			subMenuItemBorderRadius: 6,
			popupBg: '#ffffff',
			itemSelectedColor: '#13c2c2',
			itemSelectedBg: '#e6fffb',
			itemHoverColor: '#1e1e1f',
			itemHoverBg: '#e0e0e1',
			itemHeight: 44,
			itemDisabledColor: '#c1c1c3',
			itemColor: '#1e1e1f',
			itemBorderRadius: 12,
			itemBg: '#ffffff',
			iconSize: 14,
			horizontalItemSelectedColor: '#13c2c2',
			horizontalItemSelectedBg: 'rgba(0, 0, 0, 0)',
			horizontalItemHoverColor: '#13c2c2',
			horizontalItemHoverBg: 'rgba(0, 0, 0, 0)',
			groupTitleColor: '#828486',
			darkItemSelectedColor: '#ffffff',
			darkItemSelectedBg: '#13c2c2',
			darkItemHoverColor: '#ffffff',
			darkItemHoverBg: 'rgba(0, 0, 0, 0)',
			collapsedIconSize: 16,
			darkPopupBg: '#001529',
			activeBarBorderWidth: 1,
			collapsedWidth: 80,
			dropdownWidth: 160,
			itemMarginBlock: 4,
			itemMarginInline: 4,
			iconMarginInlineEnd: 10,
			groupTitleFontSize: 14,
			groupTitleLineHeight: 1.5714285714285714,
			fontFamily: 'Roboto',
			horizontalLineHeight: '36px',
		},
		InputNumber: {
			paddingInlineSM: 7,
			paddingInlineLG: 11,
			paddingInline: 11,
			paddingBlockSM: 0,
			paddingBlockLG: 7,
			paddingBlock: 4,
			handleWidth: 22,
			controlWidth: 90,
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			lineWidth: 1,
			lineHeightLG: 1.5,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlPaddingHorizontalSM: 8,
			controlPaddingHorizontal: 12,
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorWarningBorderHover: '#ffd666',
			colorWarning: '#faad14',
			colorTextPlaceholder: '#c1c1c3',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimary: '#13c2c2',
			colorFillAlter: '#eff0f0',
			colorErrorBorderHover: '#ffa39e',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			hoverBorderColor: '#36cfc9',
			handleHoverColor: '#13c2c2',
			handleBorderColor: '#e0e0e1',
			handleBg: '#ffffff',
			handleActiveBg: '#eff0f0',
			addonBg: '#eff0f0',
			activeBorderColor: '#13c2c2',
			activeBg: '#ffffff',
			hoverBg: '#ffffff',
			inputFontSize: 14,
			inputFontSizeLG: 16,
			inputFontSizeSM: 12,
			fontFamily: 'Roboto',
			colorTextQuaternary: '#c1c1c3',
			colorFillSecondary: '#e0e0e1',
			colorFillTertiary: '#eff0f0',
			colorWarningBg: '#fffbe6',
			colorWarningBgHover: '#fff1b8',
			colorErrorBg: '#fff2f0',
			colorErrorBgHover: '#fff1f0',
			filledHandleBg: '#ffffff',
			colorErrorText: '#ff4d4f',
			colorWarningText: '#faad14',
		},
		Image: {
			previewOperationSize: 18,
			previewOperationHoverColor: 'rgba(255, 255, 255, 0.85)',
			previewOperationColorDisabled: 'rgba(255, 255, 255, 0.25)',
			previewOperationColor: 'rgba(255, 255, 255, 0.65)',
			paddingXXS: 4,
			paddingSM: 12,
			paddingLG: 24,
			marginXXS: 4,
			marginXL: 32,
			marginSM: 12,
			margin: 16,
			fontSizeIcon: 12,
			controlHeightLG: 44,
			colorTextLightSolid: '#ffffff',
			colorBgMask: 'rgba(130, 132, 134, 0.60)',
			colorBgContainerDisabled: '#eff0f0',
		},
		Card: {
			headerHeightSM: 38,
			headerHeight: 56,
			paddingXS: 8,
			paddingSM: 12,
			paddingLG: 24,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			lineWidth: 1,
			lineHeightLG: 1.5,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSize: 14,
			borderRadiusLG: 12,
			colorTextHeading: '#1e1e1f',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimary: '#13c2c2',
			colorFillAlter: '#eff0f0',
			colorBorderSecondary: '#eff0f0',
			colorBgContainer: '#ffffff',
			headerBg: 'rgba(0, 0, 0, 0)',
			headerFontSize: 16,
			headerFontSizeSM: 14,
			fontHeight: 22,
			fontSizeLG: 16,
			fontFamily: 'Roboto',
		},
		Carousel: {
			dotWidth: 16,
			dotHeight: 3,
			dotActiveWidth: 24,
			marginXXS: 4,
			lineHeight: 1.5714285714285714,
			fontSize: 14,
			controlHeightSM: 36,
			controlHeightLG: 44,
			colorText: '#1e1e1f',
			colorBgContainer: '#ffffff',
			fontFamily: 'Roboto',
		},
		Cascader: {
			dropdownHeight: 180,
			controlWidth: 184,
			controlItemWidth: 111,
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			marginXS: 8,
			lineWidthFocus: 4,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeLG: 16,
			fontSizeIcon: 12,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlInteractiveSize: 16,
			controlHeight: 40,
			borderRadiusSM: 6,
			colorWhite: '#ffffff',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorBorder: '#e0e0e1',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			optionSelectedBg: '#e6fffb',
			menuPadding: 4,
			optionSelectedFontWeight: 600,
			fontFamily: 'Roboto',
		},
		Calendar: {
			yearControlWidth: 80,
			monthControlWidth: 70,
			controlHeight: 40,
			screenXS: 480,
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeightSM: 1.6666666666666667,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeSM: 12,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlHeightSM: 36,
			controlHeightLG: 44,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			colorTextLightSolid: '#ffffff',
			colorTextHeading: '#1e1e1f',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimary: '#13c2c2',
			colorLinkHover: '#36cfc9',
			colorLinkActive: '#08979c',
			colorLink: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			itemActiveBg: '#e6fffb',
			fullPanelBg: '#ffffff',
			fullBg: '#ffffff',
			fontHeightSM: 20,
			fontFamily: 'Roboto',
		},
		Button: {
			paddingInlineSM: 12,
			paddingInlineLG: 16,
			paddingInline: 16,
			onlyIconSizeSM: 14,
			onlyIconSizeLG: 18,
			paddingXS: 8,
			paddingContentHorizontal: 16,
			marginXS: 8,
			lineWidthFocus: 4,
			lineWidth: 1,
			contentLineHeight: 1.5714285714285714,
			contentFontSizeLG: 16,
			contentFontSize: 14,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusSM: 6,
			borderRadiusLG: 8,
			borderRadius: 8,
			colorTextLightSolid: '#ffffff',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimaryActive: '#08979c',
			colorPrimary: '#13c2c2',
			colorLinkHover: '#36cfc9',
			colorLinkActive: '#08979c',
			colorLink: '#13c2c2',
			colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
			colorErrorHover: '#ff7875',
			colorErrorBorderHover: '#ffa39e',
			colorErrorBg: '#fff2f0',
			colorErrorActive: '#d9363e',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			colorBgTextActive: '#d0d1d2',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			textHoverBg: '#e0e0e1',
			primaryColor: '#ffffff',
			onlyIconSize: 16,
			linkHoverBg: 'rgba(0, 0, 0, 0)',
			groupBorderColor: '#36cfc9',
			ghostBg: 'rgba(0, 0, 0, 0)',
			defaultGhostColor: '#ffffff',
			defaultGhostBorderColor: '#ffffff',
			defaultColor: '#1e1e1f',
			defaultBorderColor: '#e0e0e1',
			defaultBg: '#ffffff',
			dangerColor: '#ffffff',
			borderColorDisabled: '#e0e0e1',
			defaultHoverBg: '#ffffff',
			defaultHoverColor: '#36cfc9',
			defaultHoverBorderColor: '#36cfc9',
			defaultActiveBg: '#ffffff',
			defaultActiveColor: '#08979c',
			defaultActiveBorderColor: '#08979c',
			fontWeight: 400,
			contentFontSizeSM: 14,
			contentLineHeightLG: 1.5,
			contentLineHeightSM: 1.5714285714285714,
		},
		Badge: {
			statusSize: 6,
			indicatorHeight: 20,
			dotSize: 6,
			paddingXS: 8,
			marginXS: 8,
			lineWidth: 1,
			borderRadiusSM: 6,
			fontSizeSM: 12,
			fontSize: 14,
			colorWarning: '#faad14',
			colorTextPlaceholder: '#c1c1c3',
			colorTextLightSolid: '#ffffff',
			colorText: '#1e1e1f',
			colorSuccess: '#52c41a',
			colorPrimary: '#13c2c2',
			colorErrorHover: '#ff7875',
			colorError: '#ff4d4f',
			colorBorderBg: '#ffffff',
			colorBgContainer: '#ffffff',
			indicatorHeightSM: 14,
			textFontSize: 12,
			textFontSizeSM: 12,
			fontHeight: 22,
			lineHeight: 1.5714285714285714,
			fontFamily: 'Roboto',
		},
		Form: {
			screenXSMax: 575,
			screenSMMax: 767,
			screenMDMax: 991,
			screenLGMax: 1199,
			paddingXS: 8,
			paddingSM: 12,
			marginXXS: 4,
			marginXS: 8,
			marginLG: 24,
			margin: 16,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			colorWarning: '#faad14',
			colorTextHeading: '#1e1e1f',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSuccess: '#52c41a',
			colorPrimary: '#13c2c2',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			labelRequiredMarkColor: '#ff4d4f',
			labelColor: '#1e1e1f',
			itemMarginBottom: 0,
			labelColonMarginInlineEnd: 8,
			labelColonMarginInlineStart: 2,
			labelHeight: 40,
			labelFontSize: 14,
			fontFamily: 'Roboto',
		},
		Avatar: {
			marginXXS: 4,
			marginXS: 8,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeXL: 20,
			fontSizeLG: 16,
			fontSizeHeading3: 24,
			fontSize: 14,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorTextPlaceholder: '#c1c1c3',
			colorTextLightSolid: '#ffffff',
			colorText: '#1e1e1f',
			colorBorderBg: '#ffffff',
			containerSizeSM: 36,
			containerSizeLG: 44,
			containerSize: 40,
			textFontSize: 18,
			textFontSizeLG: 24,
			textFontSizeSM: 14,
			fontFamily: 'Roboto',
		},
		Tour: {
			sizePopupArrow: 16,
			paddingXS: 8,
			padding: 16,
			marginXS: 8,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSize: 14,
			borderRadiusXS: 4,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorWhite: '#ffffff',
			colorTextLightSolid: '#ffffff',
			colorText: '#1e1e1f',
			colorPrimary: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorFill: '#d0d1d2',
			colorBgTextHover: '#e0e0e1',
			colorBgElevated: '#ffffff',
			closeBtnSize: 22,
			primaryNextBtnHoverBg: '#f0f0f0',
			primaryPrevBtnBg: 'rgba(255, 255, 255, 0.15)',
			fontFamily: 'Roboto',
			lineWidthFocus: 4,
		},
		QRCode: {
			paddingSM: 12,
			marginXS: 8,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSize: 14,
			controlHeight: 40,
			borderRadiusLG: 12,
			colorWhite: '#ffffff',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			fontFamily: 'Roboto',
		},
		Upload: {
			paddingXS: 8,
			paddingSM: 12,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			marginXL: 32,
			margin: 16,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSizeHeading3: 24,
			fontSizeHeading2: 30,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlHeightLG: 44,
			borderRadiusLG: 12,
			colorTextLightSolid: '#ffffff',
			colorTextHeading: '#1e1e1f',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimary: '#13c2c2',
			colorFillAlter: '#eff0f0',
			colorErrorBg: '#fff2f0',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			colorBgMask: 'rgba(130, 132, 134, 0.60)',
			fontHeight: 22,
			fontHeightSM: 20,
			lineWidthFocus: 4,
			fontFamily: 'Roboto',
		},
		Typography: {
			paddingSM: 12,
			marginXXS: 4,
			marginXS: 8,
			lineWidth: 1,
			lineHeightHeading5: 1.5,
			lineHeightHeading4: 1.4,
			lineHeightHeading3: 1.3333333333333333,
			lineHeightHeading2: 1.2666666666666666,
			lineHeightHeading1: 1.2105263157894737,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeHeading5: 16,
			fontSizeHeading4: 20,
			fontSizeHeading3: 24,
			fontSizeHeading2: 30,
			fontSizeHeading1: 38,
			fontSize: 14,
			colorWarning: '#faad14',
			colorTextHeading: '#1e1e1f',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSuccess: '#52c41a',
			colorLinkHover: '#36cfc9',
			colorLinkActive: '#08979c',
			colorLink: '#13c2c2',
			colorErrorHover: '#ff7875',
			colorErrorActive: '#d9363e',
			colorError: '#ff4d4f',
			fontFamilyCode: 'Roboto Mono',
		},
		TreeSelect: {
			paddingXS: 8,
			marginXXS: 4,
			marginXS: 8,
			lineWidthFocus: 4,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlInteractiveSize: 16,
			controlHeightSM: 36,
			borderRadiusSM: 6,
			borderRadius: 8,
			colorWhite: '#ffffff',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorBorder: '#e0e0e1',
			colorBgElevated: '#ffffff',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			titleHeight: 36,
			nodeSelectedBg: '#e6fffb',
			nodeHoverBg: '#eff0f0',
			fontFamily: 'Roboto',
		},
		Tree: {
			paddingSM: 12,
			borderRadiusLG: 12,
			paddingXS: 8,
			marginXXS: 4,
			marginXS: 8,
			lineWidthFocus: 4,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlInteractiveSize: 16,
			controlHeightSM: 36,
			borderRadiusSM: 6,
			borderRadius: 8,
			colorWhite: '#ffffff',
			colorTextLightSolid: '#ffffff',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorBorder: '#e0e0e1',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			titleHeight: 36,
			nodeSelectedBg: '#e6fffb',
			nodeHoverBg: '#eff0f0',
			directoryNodeSelectedColor: '#ffffff',
			directoryNodeSelectedBg: '#13c2c2',
			fontFamily: 'Roboto',
		},
		Tag: {
			paddingXXS: 4,
			marginXS: 8,
			lineWidth: 1,
			lineHeightSM: 1.6666666666666667,
			lineHeight: 1.5714285714285714,
			fontSizeSM: 12,
			fontSizeIcon: 12,
			fontSize: 14,
			borderRadiusSM: 6,
			colorTextLightSolid: '#ffffff',
			colorTextHeading: '#1e1e1f',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryActive: '#08979c',
			colorPrimary: '#13c2c2',
			colorFillTertiary: '#eff0f0',
			colorFillSecondary: '#e0e0e1',
			colorFillQuaternary: '#eff0f0',
			colorBorder: '#e0e0e1',
			colorWarningBorder: '#ffe58f',
			colorWarningBg: '#fffbe6',
			colorSuccessBorder: '#b7eb8f',
			colorSuccessBg: '#f6ffed',
			colorInfoBorder: '#87e8de',
			colorInfoBg: '#e6fffb',
			colorErrorBorder: '#ffccc7',
			colorErrorBg: '#fff2f0',
			defaultColor: '#1e1e1f',
			defaultBg: '#eff0f0',
			fontFamily: 'Roboto',
		},
		Statistic: {
			padding: 16,
			marginXXS: 4,
			lineHeight: 1.5714285714285714,
			fontSizeHeading3: 24,
			fontSize: 14,
			colorTextHeading: '#1e1e1f',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			contentFontSize: 24,
			titleFontSize: 14,
			fontFamily: 'Roboto',
		},
		Skeleton: {
			padding: 16,
			marginXXS: 4,
			marginSM: 12,
			marginLG: 24,
			controlHeightXS: 30,
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusSM: 6,
			colorFillContent: '#e0e0e1',
			colorFill: '#d0d1d2',
		},
		Select: {
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeSM: 12,
			fontSizeLG: 16,
			fontSizeIcon: 12,
			fontSize: 14,
			controlPaddingHorizontalSM: 8,
			controlPaddingHorizontal: 12,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlHeightXS: 30,
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusXS: 4,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
			colorWarningHover: '#ffd666',
			colorTextTertiary: '#828486',
			colorTextQuaternary: '#c1c1c3',
			colorTextPlaceholder: '#c1c1c3',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimary: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorFillSecondary: '#e0e0e1',
			colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
			colorErrorHover: '#ff7875',
			colorBorder: '#e0e0e1',
			colorBgElevated: '#ffffff',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			singleItemHeightLG: 44,
			selectorBg: '#ffffff',
			optionSelectedColor: '#1e1e1f',
			optionSelectedBg: '#e6fffb',
			optionHeight: 40,
			optionActiveBg: '#eff0f0',
			multipleSelectorBgDisabled: '#eff0f0',
			multipleItemHeightLG: 40,
			multipleItemHeight: 36,
			multipleItemColorDisabled: '#c1c1c3',
			multipleItemBorderColorDisabled: 'rgba(0, 0, 0, 0)',
			multipleItemBorderColor: 'rgba(0, 0, 0, 0)',
			multipleItemBg: '#e0e0e1',
			clearBg: '#ffffff',
			optionFontSize: 14,
			optionSelectedFontWeight: 600,
			fontFamily: 'Roboto',
			showArrowPaddingInlineEnd: 18,
		},
		Result: {
			paddingXS: 8,
			paddingXL: 32,
			paddingLG: 24,
			padding: 16,
			marginXS: 8,
			lineHeightHeading3: 1.3333333333333333,
			lineHeight: 1.5714285714285714,
			fontSizeHeading3: 24,
			fontSize: 14,
			colorWarning: '#faad14',
			colorTextHeading: '#1e1e1f',
			colorTextDescription: '#828486',
			colorSuccess: '#52c41a',
			colorInfo: '#13c2c2',
			colorFillAlter: '#eff0f0',
			colorError: '#ff4d4f',
			iconFontSize: 72,
			subtitleFontSize: 14,
			titleFontSize: 24,
		},
		Progress: {
			paddingXS: 8,
			marginXXS: 4,
			marginXS: 8,
			lineHeight: 1.5714285714285714,
			fontSizeSM: 12,
			fontSize: 14,
			colorText: '#1e1e1f',
			colorSuccess: '#52c41a',
			colorFillSecondary: '#e0e0e1',
			colorError: '#ff4d4f',
			colorBgContainer: '#ffffff',
			remainingColor: '#e0e0e1',
			defaultColor: '#13c2c2',
			circleTextColor: '#1e1e1f',
			fontFamily: 'Roboto',
		},
		Popconfirm: {
			marginXXS: 4,
			marginXS: 8,
			fontWeightStrong: 600,
			fontSize: 14,
			colorWarning: '#faad14',
			colorTextHeading: '#1e1e1f',
			colorText: '#1e1e1f',
		},
		Pagination: {
			screenSM: 576,
			screenLG: 992,
			paddingXXS: 4,
			paddingSM: 12,
			marginXXS: 4,
			marginXS: 8,
			marginSM: 12,
			margin: 16,
			lineWidthFocus: 4,
			lineWidth: 1,
			lineHeightLG: 1.5,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeSM: 12,
			fontSizeLG: 16,
			fontSize: 14,
			controlPaddingHorizontalSM: 8,
			controlPaddingHorizontal: 12,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlItemBgActiveDisabled: '#d0d1d2',
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
			colorTextPlaceholder: '#c1c1c3',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorFillAlter: '#eff0f0',
			colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
			colorBorder: '#e0e0e1',
			colorBgTextHover: '#e0e0e1',
			colorBgTextActive: '#d0d1d2',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			itemSizeSM: 36,
			itemSize: 40,
			itemLinkBg: '#ffffff',
			itemInputBg: '#ffffff',
			itemBg: '#ffffff',
			itemActiveColorDisabled: '#c1c1c3',
			itemActiveBgDisabled: '#d0d1d2',
			itemActiveBg: '#ffffff',
			fontFamily: 'Roboto',
		},
		Modal: {
			screenSMMax: 767,
			paddingXS: 8,
			paddingMD: 24,
			paddingLG: 24,
			paddingContentHorizontalLG: 24,
			padding: 16,
			marginXS: 8,
			marginSM: 12,
			marginLG: 24,
			margin: 16,
			lineWidthFocus: 4,
			lineWidth: 1,
			lineHeightHeading5: 1.5,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeLG: 16,
			fontSizeHeading5: 16,
			fontSize: 14,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			colorWarning: '#faad14',
			colorTextHeading: '#1e1e1f',
			colorText: '#1e1e1f',
			colorSuccess: '#52c41a',
			colorPrimaryBorder: '#87e8de',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorBgMask: 'rgba(130, 132, 134, 0.60)',
			titleColor: '#1e1e1f',
			headerBg: '#ffffff',
			footerBg: 'rgba(0, 0, 0, 0)',
			contentBg: '#ffffff',
			titleFontSize: 16,
			titleLineHeight: 1.375,
			fontHeight: 22,
			fontFamily: 'Roboto',
		},
		Message: {
			paddingXS: 8,
			paddingSM: 12,
			marginXS: 8,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlHeightLG: 44,
			borderRadiusLG: 12,
			colorWarning: '#faad14',
			colorText: '#1e1e1f',
			colorSuccess: '#52c41a',
			colorInfo: '#13c2c2',
			colorError: '#ff4d4f',
			contentBg: '#ffffff',
			fontFamily: 'Roboto',
		},
		List: {
			screenSM: 576,
			screenMD: 768,
			paddingXS: 8,
			paddingSM: 12,
			paddingLG: 24,
			paddingContentVerticalSM: 8,
			paddingContentVerticalLG: 16,
			paddingContentVertical: 12,
			paddingContentHorizontalLG: 24,
			paddingContentHorizontal: 16,
			padding: 16,
			marginXXS: 4,
			marginXXL: 48,
			marginSM: 12,
			marginLG: 24,
			margin: 16,
			lineWidth: 1,
			lineHeightLG: 1.5,
			lineHeight: 1.5714285714285714,
			fontSizeSM: 12,
			fontSizeLG: 16,
			fontSize: 14,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusLG: 12,
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimary: '#13c2c2',
			colorBorder: '#e0e0e1',
			headerBg: '#ccc',
			footerBg: 'rgba(0, 0, 0, 0)',
			avatarMarginRight: 16,
			descriptionFontSize: 14,
			fontFamily: 'Roboto',
		},
		FloatButton: {
			paddingXXS: 4,
			marginXXL: 48,
			marginLG: 24,
			margin: 16,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeSM: 12,
			fontSizeLG: 16,
			fontSizeIcon: 12,
			fontSize: 14,
			controlItemBgHover: '#eff0f0',
			controlHeightLG: 44,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			colorTextLightSolid: '#ffffff',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimaryHover: '#36cfc9',
			colorPrimary: '#13c2c2',
			colorFillContent: '#e0e0e1',
			colorBgElevated: '#ffffff',
			fontFamily: 'Roboto',
		},
		Empty: {
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			fontSize: 14,
			lineHeight: 1.5714285714285714,
		},
		Dropdown: {
			sizePopupArrow: 16,
			paddingXXS: 4,
			paddingXS: 8,
			marginXXS: 4,
			marginXS: 8,
			lineWidthFocus: 4,
			lineHeight: 1.5714285714285714,
			fontSizeSM: 12,
			fontSizeIcon: 12,
			fontSize: 14,
			controlPaddingHorizontal: 12,
			controlItemBgHover: '#eff0f0',
			controlItemBgActiveHover: '#b5f5ec',
			controlItemBgActive: '#e6fffb',
			controlHeight: 40,
			borderRadiusXS: 4,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			colorTextLightSolid: '#ffffff',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorError: '#ff4d4f',
			colorBgElevated: '#ffffff',
			paddingBlock: 9,
			fontFamily: 'Roboto',
		},
		Drawer: {
			paddingXS: 8,
			paddingLG: 24,
			padding: 16,
			marginSM: 12,
			lineWidth: 1,
			lineHeightLG: 1.5,
			fontWeightStrong: 600,
			fontSizeLG: 16,
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorBgMask: 'rgba(130, 132, 134, 0.60)',
			colorBgElevated: '#ffffff',
			lineWidthFocus: 4,
		},
		Divider: {
			marginXS: 8,
			marginLG: 24,
			margin: 16,
			lineWidth: 1,
			fontSizeLG: 16,
			fontSize: 14,
			colorTextHeading: '#1e1e1f',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			lineHeight: 1.5714285714285714,
			fontFamily: 'Roboto',
		},
		Descriptions: {
			paddingXS: 8,
			paddingSM: 12,
			paddingLG: 24,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			lineWidth: 1,
			lineHeightSM: 1.6666666666666667,
			lineHeightLG: 1.5,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeSM: 12,
			fontSizeLG: 16,
			fontSize: 14,
			borderRadiusLG: 12,
			colorTextTertiary: '#828486',
			colorTextSecondary: '#4f5153',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorFillAlter: '#eff0f0',
			titleColor: '#1e1e1f',
			labelBg: '#eff0f0',
			contentColor: '#1e1e1f',
			fontFamily: 'Roboto',
		},
		DatePicker: {
			sizePopupArrow: 16,
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			padding: 16,
			marginXXS: 4,
			marginXS: 8,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeightLG: 1.5,
			lineHeight: 1.5714285714285714,
			fontWeightStrong: 600,
			fontSizeLG: 16,
			fontSize: 14,
			controlPaddingHorizontalSM: 8,
			controlPaddingHorizontal: 12,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusXS: 4,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
			colorWarningHover: '#ffd666',
			colorWarning: '#faad14',
			colorTextQuaternary: '#c1c1c3',
			colorTextPlaceholder: '#c1c1c3',
			colorTextLightSolid: '#ffffff',
			colorTextHeading: '#1e1e1f',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorLinkHover: '#36cfc9',
			colorLinkActive: '#08979c',
			colorLink: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorFillAlter: '#eff0f0',
			colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
			colorErrorHover: '#ff7875',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			colorBgElevated: '#ffffff',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			hoverBorderColor: '#36cfc9',
			cellHoverBg: '#eff0f0',
			cellHeight: 36,
			activeBorderColor: '#13c2c2',
			paddingInline: 11,
			paddingInlineSM: 7,
			colorFillTertiary: '#eff0f0',
			colorErrorBg: '#fff2f0',
			colorWarningBg: '#fffbe6',
			colorWarningText: '#faad14',
			colorErrorText: '#ff4d4f',
			colorWarningBgHover: '#fff1b8',
			colorErrorBgHover: '#fff1f0',
			activeBg: '#ffffff',
			hoverBg: '#ffffff',
			cellBgDisabled: '#eff0f0',
			cellActiveWithRangeBg: '#e6fffb',
			cellHoverWithRangeBg: '#c8dfff',
			cellRangeBorderColor: '#7cb3ff',
			multipleItemBg: '#e0e0e1',
			multipleItemBorderColor: 'rgba(0, 0, 0, 0)',
			multipleItemBorderColorDisabled: 'rgba(0, 0, 0, 0)',
			multipleItemColorDisabled: '#c1c1c3',
			multipleSelectorBgDisabled: '#eff0f0',
			cellWidth: 36,
			multipleItemHeight: 24,
			multipleItemHeightLG: 32,
			multipleItemHeightSM: 16,
			paddingBlock: 4,
			paddingBlockLG: 7,
			paddingBlockSM: 0,
			'paddingInline 2': 11,
			presetsMaxWidth: 200,
			presetsWidth: 120,
			textHeight: 44,
			timeCellHeight: 28,
			timeColumnHeight: 224,
			timeColumnWidth: 56,
			withoutTimeCellHeight: 66,
			inputFontSize: 14,
			inputFontSizeLG: 16,
			inputFontSizeSM: 12,
			fontHeight: 22,
			fontHeightLG: 24,
			fontFamily: 'Roboto',
		},
		Collapse: {
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			paddingLG: 24,
			padding: 16,
			marginSM: 12,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSizeIcon: 12,
			fontSize: 14,
			borderRadiusLG: 12,
			colorTextHeading: '#1e1e1f',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorFillAlter: '#eff0f0',
			colorBorder: '#e0e0e1',
			colorBgContainer: '#ffffff',
			headerBg: '#eff0f0',
			contentBg: '#ffffff',
			fontHeight: 22,
			fontHeightLG: 24,
			lineHeightLG: 1.5,
			fontFamily: 'Roboto',
		},
		Checkbox: {
			paddingXS: 8,
			marginXS: 8,
			lineWidthFocus: 4,
			lineWidthBold: 2,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			controlInteractiveSize: 16,
			borderRadiusSM: 6,
			colorWhite: '#ffffff',
			colorTextDisabled: '#c1c1c3',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimaryBorder: '#87e8de',
			colorPrimary: '#13c2c2',
			colorBorder: '#e0e0e1',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			fontFamily: 'Roboto',
		},
		Breadcrumb: {
			paddingXXS: 4,
			marginXXS: 4,
			marginXS: 8,
			lineWidthFocus: 4,
			lineHeight: 1.5714285714285714,
			fontSizeIcon: 12,
			fontSize: 14,
			borderRadiusSM: 6,
			colorPrimaryBorder: '#87e8de',
			colorBgTextHover: '#e0e0e1',
			separatorColor: '#828486',
			linkHoverColor: '#1e1e1f',
			linkColor: '#828486',
			lastItemColor: '#1e1e1f',
			itemColor: '#828486',
			separatorMargin: 8,
			iconFontSize: 14,
			fontHeight: 22,
			fontFamily: 'Roboto',
		},
		Anchor: {
			paddingXXS: 4,
			lineWidthBold: 2,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSize: 14,
			colorText: '#1e1e1f',
			colorSplit: '#eff0f0',
			colorPrimary: '#13c2c2',
			linkPaddingInlineStart: 16,
			linkPaddingBlock: 4,
			fontFamily: 'Roboto',
		},
		Alert: {
			paddingMD: 20,
			paddingContentVerticalSM: 8,
			paddingContentHorizontalLG: 24,
			marginXS: 8,
			marginSM: 12,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			fontSizeLG: 16,
			fontSizeIcon: 12,
			fontSizeHeading3: 24,
			fontSize: 14,
			borderRadiusLG: 12,
			colorWarningBorder: '#ffe58f',
			colorWarningBg: '#fffbe6',
			colorWarning: '#faad14',
			colorTextHeading: '#1e1e1f',
			colorText: '#1e1e1f',
			colorSuccessBorder: '#b7eb8f',
			colorSuccessBg: '#f6ffed',
			colorSuccess: '#52c41a',
			colorInfoBorder: '#87e8de',
			colorInfoBg: '#e6fffb',
			colorInfo: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorErrorBorder: '#ffccc7',
			colorErrorBg: '#fff2f0',
			colorError: '#ff4d4f',
			withDescriptionIconSize: 24,
			fontFamily: 'Roboto',
		},
		Space: {
			paddingXS: 8,
			paddingLG: 24,
			padding: 16,
		},
		AutoComplete: {
			paddingXXS: 4,
			paddingXS: 8,
			paddingSM: 12,
			lineWidth: 1,
			lineHeight: 1.5714285714285714,
			controlPaddingHorizontalSM: 8,
			controlPaddingHorizontal: 12,
			controlOutlineWidth: 2,
			controlOutline: 'rgba(5, 145, 255, 0.1)',
			controlItemBgHover: '#eff0f0',
			controlItemBgActive: '#e6fffb',
			controlHeightXS: 30,
			controlHeightSM: 36,
			controlHeightLG: 44,
			controlHeight: 40,
			borderRadiusXS: 4,
			borderRadiusSM: 6,
			borderRadiusLG: 12,
			borderRadius: 8,
			colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
			colorWarningHover: '#ffd666',
			colorWarning: '#faad14',
			colorTextTertiary: '#828486',
			colorTextQuaternary: '#c1c1c3',
			colorTextPlaceholder: '#c1c1c3',
			colorTextDisabled: '#c1c1c3',
			colorTextDescription: '#828486',
			colorText: '#1e1e1f',
			colorPrimaryHover: '#36cfc9',
			colorPrimary: '#13c2c2',
			colorIconHover: '#1e1e1f',
			colorIcon: '#828486',
			colorFillSecondary: '#e0e0e1',
			colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
			colorErrorHover: '#ff7875',
			colorError: '#ff4d4f',
			colorBorder: '#e0e0e1',
			colorBgElevated: '#ffffff',
			colorBgContainerDisabled: '#eff0f0',
			colorBgContainer: '#ffffff',
			optionActiveBg: 'rgba(0, 0, 0, 0.04)',
			optionHeight: 32,
			optionFontSize: 14,
			fontFamily: 'Roboto',
			fontSize: 14,
			fontSizeIcon: 12,
			fontSizeLG: 16,
			fontSizeSM: 12,
		},
		Layout: {
			bodyBg: '#f5f5f5',
			footerBg: '#f5f5f5',
			headerBg: '#f5f5f5',
			headerColor: '#1e1e1f',
			lightSiderBg: '#ffffff',
			lightTriggerBg: '#ffffff',
			lightTriggerColor: '#1e1e1f',
			siderBg: '#001529',
			triggerBg: '#002140',
			triggerColor: '#ffffff',
			colorText: '#1e1e1f',
			headerHeight: 64,
			triggerHeight: 48,
			zeroTriggerHeight: 44,
			zeroTriggerWidth: 44,
			borderRadius: 8,
			fontSize: 14,
			fontSizeXL: 20,
		},
		Mentions: {
			fontFamily: 'Roboto',
			fontSize: 14,
			lineHeight: 1.5714285714285714,
		},
	},
};
